import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import Alissa from '../../../../../public/assets/our-story/company-founded/alissa-founded.webp'
import Sisters from '../../../../../public/assets/our-story/company-founded/sister-founded.webp'
import AlissaRescue from '../../../../../public/assets/our-story/company-founded/alissa-rescue.webp'
import WhiteBlob from '../../../../../public/assets/our-story/white-blob.svg'
import HeartSparkle from '../../../../../public/assets/illustration-heart-sparkle.svg'
import HeartAccent from '../../../../../public/assets/recipes/categories/wfr-heart.webp'
import {
  CompanyFoundedDescription,
  CompanyFoundedRoot,
  CompanyFoundedText,
  CompanyFoundedImages,
  CompanyFoundedContainer,
  HeartImage,
  HeartIcon,
  CompanyFoundedDeskFlex,
  CaptionContainer,
  CompanyFoundedButtonContainer,
  CompanyFoundedCarouselContainer,
} from './CompanyFounded.styles'
import { PhotoCaption, WhiteBlobContainer } from '../../OurStory.styles'
import { CompanyFoundedCarousel } from './CompanyFoundedCarousel'
import Link from 'next/link'
import { Button } from 'components/Button'

export const CompanyFounded = ({ isDesktop }: any) => {
  const { t } = useTranslation()

  return (
    <CompanyFoundedRoot>
      <CompanyFoundedDeskFlex>
        <CompanyFoundedContainer gap="small">
          <WhiteBlobContainer location="3" rotation="1">
            <Image src={WhiteBlob} alt="" />
          </WhiteBlobContainer>
          <WhiteBlobContainer location="4" rotation="1">
            <Image src={WhiteBlob} alt="" />
          </WhiteBlobContainer>
          <CompanyFoundedImages>
            <CaptionContainer>
              <Image src={Alissa} alt={t('our-story:company-founded.photo-caption-1')} />
              <PhotoCaption position="bottom">
                {t('our-story:company-founded.photo-caption-1')}
              </PhotoCaption>
            </CaptionContainer>
            <CaptionContainer>
              <Image src={Sisters} alt={t('our-story:company-founded.photo-caption-2')} />
              <PhotoCaption position="bottom">
                {t('our-story:company-founded.photo-caption-2')}
              </PhotoCaption>
            </CaptionContainer>
          </CompanyFoundedImages>
          <CompanyFoundedText>
            {isDesktop ? (
              <CompanyFoundedDescription>
                <b>{t('our-story:company-founded.highlight-1')}</b>{' '}
                {t('our-story:company-founded.text-1')}
              </CompanyFoundedDescription>
            ) : (
              <CompanyFoundedDescription>
                <b>{t('our-story:company-founded.highlight-2')}</b>{' '}
                {t('our-story:company-founded.text-2')}
              </CompanyFoundedDescription>
            )}
            <HeartImage>
              <Image src={HeartSparkle} alt="" />
            </HeartImage>
          </CompanyFoundedText>
        </CompanyFoundedContainer>

        <CompanyFoundedContainer reverse="true" gap="large">
          <CompanyFoundedImages>
            <HeartIcon>
              <Image src={HeartAccent} alt="" />
            </HeartIcon>
            <Image src={AlissaRescue} alt={t('our-story:company-founded.photo-caption-3')} />
            <PhotoCaption position="bottomTop">
              {t('our-story:company-founded.photo-caption-3')}
            </PhotoCaption>
          </CompanyFoundedImages>
          <CompanyFoundedText>
            {isDesktop ? (
              <CompanyFoundedDescription>
                <b>{t('our-story:company-founded.highlight-2')}</b>{' '}
                {t('our-story:company-founded.text-2')}
              </CompanyFoundedDescription>
            ) : (
              <CompanyFoundedDescription>
                <b>{t('our-story:company-founded.highlight-1')}</b>{' '}
                {t('our-story:company-founded.text-1')}
              </CompanyFoundedDescription>
            )}
          </CompanyFoundedText>
        </CompanyFoundedContainer>
      </CompanyFoundedDeskFlex>
      <CompanyFoundedCarouselContainer>
        <CompanyFoundedCarousel isDesktop={isDesktop} />
      </CompanyFoundedCarouselContainer>
      <CompanyFoundedButtonContainer>
        <Link href="/meal-plan">
          <Button>{t('our-story:company-founded.button')}</Button>
        </Link>
      </CompanyFoundedButtonContainer>
    </CompanyFoundedRoot>
  )
}
